var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keyUser && _vm.keyUser.customer)?_c('span',[_vm._v(" "+_vm._s(_vm.keyUser.customer.kunde)+" "),_c('small',[_vm._v("("+_vm._s(_vm.keyUser.customer.cardcode)+")")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }